// eslint-disable-next-line no-unused-vars
let db

const dbName = 'db-chat'
const dbVersion = 2
const dtChatName = 't-chat-msg'

const request = window.indexedDB.open(dbName, dbVersion)

request.onerror = function () {
  console.log('msg', '数据库打开失败')
}
request.onsuccess = function (event) {
  db = event.target.result
  console.log('msg', '数据库打开成功')
}
request.onupgradeneeded = function (event) {
  db = event.target.result
  // eslint-disable-next-line no-unused-vars
  let objectStore
  if (!db.objectStoreNames.contains(dtChatName)) {
    objectStore = db.createObjectStore(dtChatName, {autoIncrement: true})
    // objectStore.createIndex('userId', 'name', {unique: false})
    // objectStore.createIndex('userType', 'email', {unique: false})
    // objectStore.createIndex('createTime', 'name', {unique: false})
    objectStore.createIndex('idx-userId-userType-createTime', ['userId', 'userType', 'createTime'], {unique: false})
  }
}

const save = function (userId, userType, author, timestamp, type, text, isSend, sendState) {
  if (!isSend) {
    sendState = true
  }

  const request = db.transaction([dtChatName], 'readwrite')
    .objectStore(dtChatName)
    .add({
      userId: userId,
      userType: userType,
      author: author,
      isSend: isSend,
      sendState: sendState,
      createTime: timestamp,
      msgType: type,
      content: text
    })

  request.onsuccess = function (event) {
    console.log('msg', '数据写入成功')
  }
  request.onerror = function (event) {
    console.log('msg', '数据写入失败')
  }
}

const updateSendState = function (userId, userType, sendTime, sendState) {
  const transaction = db.transaction([dtChatName], 'readwrite')
  const objectStore = transaction.objectStore(dtChatName)
  const idx = objectStore.index('idx-userId-userType-createTime')
  const request = idx.openCursor([userId, userType, sendTime])

  request.onsuccess = function (event) {
    let res = event.target.result
    if (res) {
      const msg = res.value
      msg.sendState = sendState
      const requestUpdate = objectStore.put(msg, res.primaryKey)
      requestUpdate.onsuccess = function (event) {
        console.log('msg', '数据更新成功')
      }
      requestUpdate.onerror = function (event) {
        console.log('msg', '数据更新失败')
      }
    }
  }
  request.onerror = function () {
    console.log('读取要更新的数据失败')
  }
}

const get = function (userId, userType, startTime, cb) {
  const transaction = db.transaction([dtChatName])
  const objectStore = transaction.objectStore(dtChatName)
  const idx = objectStore.index('idx-userId-userType-createTime')
  const request = idx.openCursor(IDBKeyRange.bound([userId, userType, startTime], [userId, userType, startTime + 86400000]))

  let data = []
  request.onsuccess = function (event) {
    let res = event.target.result
    if (res) {
      data.push(res.value)
      res.continue()
    } else {
      console.log('msg', '读取数据成功：', data)
      if (cb) {
        cb(data)
      }
    }
  }
  request.onerror = function () {
    console.log('msg', '读取数据失败')
  }
}

const del = function (userId, userType, endTime) {
  const transaction = db.transaction([dtChatName], 'readwrite')
  const objectStore = transaction.objectStore(dtChatName)
  const idx = objectStore.index('idx-userId-userType-createTime')
  const request = idx.openCursor(IDBKeyRange.bound([userId, userType, 0], [userId, userType, endTime]))
  request.onsuccess = function (event) {
    let res = event.target.result
    if (res) {
      const requestDelete = objectStore.delete(res.primaryKey)
      requestDelete.onsuccess = function (event) {
        console.log('msg', '数据删除成功')
      }
      requestDelete.onerror = function (event) {
        console.log('msg', '数据删除失败')
      }
      res.continue()
    }
  }
  request.onerror = function () {
    console.log('读取要删除的数据失败')
  }
}

export default {
  save,
  updateSendState,
  get,
  del
}

// msgStorage.save(args, true)
// msgStorage.get(args.userId, args.userType, args.timestamp - 86400000)
// msgStorage.del(911, 0, 1655363489797)
// msgStorage.updateSendState(911, 0, 1655363499346, false)
